import React from 'react'

export type SelectSize = 'sm' | 'md'

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  selectSize?: SelectSize
  invalid?: boolean
}

const BASE_SELECT_CLASS = 'min-w-0 w-full rounded border border-[#CBD5E1] bg-white text-sm text-gray-700 outline-none transition-colors focus:border-[#1D74D8] focus:ring-1 focus:ring-[#1D74D8] disabled:cursor-not-allowed disabled:bg-[#F8FAFC] disabled:text-gray-400'

function getSelectSizeClass(selectSize: SelectSize): string {
  return selectSize === 'md'
    ? 'px-3 py-2'
    : 'px-2 py-1.5'
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(({
  className = '',
  selectSize = 'sm',
  invalid = false,
  children,
  ...props
}, ref) => (
  <select
    ref={ref}
    aria-invalid={invalid || undefined}
    className={`${BASE_SELECT_CLASS} ${getSelectSizeClass(selectSize)}${invalid ? ' border-[#B3261E] focus:border-[#B3261E] focus:ring-[#B3261E]' : ''}${className ? ` ${className}` : ''}`}
    {...props}
  >
    {children}
  </select>
))

Select.displayName = 'Select'

export default Select
